import React from 'react';
import propTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

export const PopularDrugs = props => {
  const { popularDrugs, text, heading } = props;

  const { t, i18n } = useTranslation();

  return !isEmpty(popularDrugs) ? (
    <section className="relatedDrugs mobile-section homepage-new popularPrescriptions">
      <section className="top-drugs">
        <article>
          <h2 className="popularTitle">
            {heading ? heading : t('Popular Prescription')}
          </h2>
          <ul>
            {popularDrugs &&
              popularDrugs.map((item, id) => {
                return (
                  <>
                    {item.name && (
                      <li key={id} className="drugLists">
                        <a
                          href={`${_.withLocale(
                            i18n.language,
                            '/prescription'
                          )}/${item.seoName}`}
                        >
                          {`${item.name}`} {`${text}`}
                        </a>
                      </li>
                    )}
                  </>
                );
              })}
          </ul>
        </article>
      </section>
    </section>
  ) : null;
};

PopularDrugs.propTypes = {
  popularDrugs: propTypes.array,
  title: propTypes.string
};

PopularDrugs.defaultProps = {
  popularDrugs: [],
  title: ''
};
export default PopularDrugs;
